// extracted by mini-css-extract-plugin
module.exports =  {"content":"a10a3f92e9--content--k07WI","icon-wrapper":"a10a3f92e9--icon-wrapper--zsmIz","heading":"a10a3f92e9--heading--F2H9Q","footer":"a10a3f92e9--footer--fizR5"};